module.exports = __webpack_public_path__ + "static/media/mp3.51b0cdb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/mp3.png
// module id = 460
// module chunks = 0